<template>
  <!-- div#body:start -->
  <div id="body"
    :class="[
    {'is-hidden-header' : targetScrollFlg},
    {'is-visible-serach-settings':state.visibleWindowDetail},
    {'is-visible-menu':state.visibleMenu},
    {'is-visible-menu-left':state.visibleMenuLeft},
    {'is-focused-input':state.isFocusInput}
    ]"
  >
    <BackgroundImage />
  

    <!-- SPメニュー -->
    <SPMenu
      :parentVisibleMenu="state.visibleMenu"
      @closeMenu="state.visibleMenu = false"
    />

    <div id="wrapper">
      <div id="menu-btn" class="menu-btn">
        <div role="button" class="menu-btn-1"
          :class="{'is-active': state.visibleWindowDetail}"
          @click="state.visibleWindowDetail = !state.visibleWindowDetail"
        >
          <FontawesomeIcon :icon="['fas','search']" class="icn icn-closed"/>
          <FontawesomeIcon :icon="['fas','times']" class="icn icn-opened"/>
        </div>
        <div role="button" class="menu-btn-2"
          @click="state.visibleMenu = true;state.visibleWindowDetail = false"
        >
          <IconMenu class="icn" />
        </div>
      </div>

      <!-- 検索ウインドウ -->
      <SPGuideSearchWindowDetail
        @openSearchDetail="state.visibleSearchDetail = true"
        @handleFocusOutInput="state.isFocusInput = false"
        @handleFocusInput="state.isFocusInput = true"
        @search="state.isFocusInput = false, state.visibleWindowDetail = false"
      />

      <!-- div#header:start -->
      <div id="header">
        <header class="header">
          <SPButtonHistoryBack />
          <div class="header-title">
            <h1>ご利用ガイド</h1>
          </div>
        </header>
      </div>

      <!-- div#header:end -->
      <div id="main">
        <div class="main">
          <div class="main-heading">
            <div class="main-heading-row main-heading-result">
              <div v-if="!guide.search.load" class="main-heading-result-num">{{guide.pagenation.count}}件</div>
            </div>
          </div>
          <div class="main-container pb0"
            @scroll="handleScroll"
            >
            <p v-if="!guide.search.load && guide.pagenation.count <= 0" class="txt ml20 mr20 mt20">キーワードに合致する検索結果がありませんでした。<br>検索キーワードを変更して再度検索してください。</p>
            <ul v-else class="list-result">
              <li v-for="list in state.lists" :key="list.id" class="list-result-item">
                <div class="list-result-item-main">
                  <div class="list-result-title"><router-link :to="'/sp/guide/' + list.id" v-html="list.title"></router-link></div>
                  <p class="list-result-text" v-html="list.detail"></p>
                  <div v-if="list.category_name" class="list-result-note">
                    <span class="list-result-sup">{{list.category_name}}</span>
                  </div>
                </div>
              </li>
            </ul>
            <SPPagenation
              v-if="!guide.search.load && guide.pagenation.count > 0"
              :count="guide.pagenation.count"
              :per_page="guide.search.per_page"
              :currentPage="guide.pagenation.currentPage"
              @changePage="action.pagenation"
            />
          </div>
        </div>
      </div>

    </div>
  </div>
  <!-- div#body:end -->
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'
import '@/components/style/SPCommonCSS.vue'
import '@/components/style/module/LayoutSPCSS.vue'

import SPMenu from '@/components/sp/popup/SPMenu.vue'
import SPGuideSearchWindowDetail from '@/components/sp/popup/SPGuideSearchWindowDetail.vue'
import SPQASearchExtract from '@/components/sp/popup/SPQASearchExtract.vue'
import SPPagenation from '@/components/sp/partial/SPPagenation.vue'

import { GuideList} from '@/logic/guide/GuideList'

export default defineComponent({
  components: {
    SPMenu,
    SPGuideSearchWindowDetail,
    SPQASearchExtract,
    SPPagenation
  },
  setup (props, context) {
    return { ...GuideList(props, context) }
  }
})
</script>

<style lang="scss" scoped>
.main {
  &-container {
    @include changeHeightOnScroll(122px);
  }
}
.list-result {
  &-title {
    padding-right: 36px;
  }
}
.menu-btn {
  &-1 {
    .icn {
      transition: all .2s ease;
    }
    .icn-opened {
      opacity: 0;
    }
    .icn-closed {
      opacity: 1;
    }
  }
}

.is-visible-serach-settings {
  .menu-btn {
    transform: translate3d(0,-144px,0);
    &-1 {
      .icn {
        transition: all .2s ease;
      }
      .icn-opened {
        opacity: 1;
      }
      .icn-closed {
        opacity: 0;
      }
    }
  }
  .search-settings {
    transform: translate3d(0,0,0);
    box-shadow: 0 -8px 8px rgba(0,0,0,.16);
  }
}
</style>
